import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import React from "react";

type CalloutProps = {
  context: string;
};

const Callout: React.FC<CalloutProps> = ({ context }) => {
  return (
    <Container>
      <UI.Icon name="info" size={24} color="var(--alias-color-primary-normal)" />
      <UI.Typography type="body02 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
        {context}
      </UI.Typography>
    </Container>
  );
};

export default React.memo(Callout);

const Container = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  background: var(--global-color-blue-98);
  white-space: pre-line;
`;
